import { Skeleton, Stack, StackProps } from '@mui/material';

interface GaugeRealizedLoadingProps extends StackProps {
  className?: string;
}
export const GaugeRealizedLoading = ({
  className,
  ...props
}: GaugeRealizedLoadingProps) => {
  return (
    <Stack alignItems="center" gap={0.25} className={className} {...props}>
      <Stack gap={0} alignItems="center">
        <Skeleton variant="text" width={150} />
        <Skeleton variant="text" width={100} />
      </Stack>
      <Skeleton variant="circular" width={90} height={90} />
      <Stack direction="row" gap={4} justifyContent="center">
        <Stack gap={0.5} alignItems="center">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={40} />
        </Stack>
        <Stack gap={0.5} alignItems="center">
          <Skeleton variant="text" width={60} />
          <Skeleton variant="text" width={40} />
        </Stack>
      </Stack>
    </Stack>
  );
};
